import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getCompanyQuery = () => {
  return axios.get(apiurl?.getCompanyList);
};

const getCompanyList = () => {
  return useMutation(['getCompanyList'], getCompanyQuery);
};

export default getCompanyList;
